import {ELASTIC_BUILDINGS_ENDPOINTS} from "../utils/api";
import jwtInterceptor from "./jwtInterceptor";

class BuildingService {

    async findByLandId(landId){
        try{
            if(!landId){
                throw new Error('landId is required')
            }
            const response = await jwtInterceptor.get(ELASTIC_BUILDINGS_ENDPOINTS.findByLandId.replace(':landId', landId))
            return response.data.data
        }
        catch (error){
            throw new Error(error)
        }
    }

    async searchBuildings(search) {
        const response = await jwtInterceptor.post(ELASTIC_BUILDINGS_ENDPOINTS.search, search);
        return response.data.data
    }
}

export  const buildingService = new BuildingService();